import {
	GLOBAL_TRANSACTIONS,
	SET_GLOBAL_TRANSACTIONS,
	SET_RELOAD_TRANSACTIONS,
	RELOAD_TRANSACTIONS,
	TOAST_MESSAGES_PUSH,
	TRANSACTION_AUDIT_LOG,
	SET_TRANSACTION_AUDIT_LOG,
	SET_ALL_TRANSACTION_AUDIT_LOG,
	CLEAR_GLOBAL_TRANSACTIONS
} from '@/sections/transactions/transactions-mutation-types.js';

import { ApiLogSupportService as apiLogSupport } from '@/services/axiosHelper';
import buildRoute from '@/composables/build-route';
import { mergePayloadObjects } from '@/utils/object';
import _ from 'lodash';

const baseApi = '/globaltransactions';

export default {
	strict: process.env.NODE_ENV !== 'production',
	name: 'globaltransactions',
	namespaced: true,
	state: {
		[GLOBAL_TRANSACTIONS]: {},
		[RELOAD_TRANSACTIONS]: false,
		transactionAuditLog: {},
		allTransactionAuditLog: {}
	},
	mutations: {
		[SET_GLOBAL_TRANSACTIONS](state, data) {
			state[GLOBAL_TRANSACTIONS] = data;
		},
		[SET_RELOAD_TRANSACTIONS](state, value) {
			state[RELOAD_TRANSACTIONS] = value;
		},
		[SET_TRANSACTION_AUDIT_LOG](state, value) {
			state[TRANSACTION_AUDIT_LOG] = value;
		},
		[SET_ALL_TRANSACTION_AUDIT_LOG](state, value) {
			state.allTransactionAuditLog = value;
		},
		[CLEAR_GLOBAL_TRANSACTIONS](state) {
			state.globalTransactions = {};
		}
	},
	actions: {
		async setGlobalTransactions({ dispatch, commit, state }, parameters) {
			const { recordStart, exportData } = parameters;

			if (parameters.logEntrytransactionTypes != null) {
				if (!Array.isArray(parameters.logEntrytransactionTypes)) {
					parameters.logEntrytransactionTypes = [
						parameters.logEntrytransactionTypes
					];
				}
			}

			return new Promise((resolve, reject) => {
				apiLogSupport
					.post(`/logs${baseApi}`, parameters)
					.then(data => {
						if (recordStart === 1 && !exportData) {
							commit(CLEAR_GLOBAL_TRANSACTIONS);
						}

						if (exportData) {
							resolve(data);
						} else {
							if (_.isEmpty(state[GLOBAL_TRANSACTIONS])) {
								commit(SET_GLOBAL_TRANSACTIONS, data);
								resolve(data);
							} else {
								let currentStore = _.cloneDeep(
									state[GLOBAL_TRANSACTIONS]
								);
								let globalTransactionsPayload = mergePayloadObjects(
									currentStore,
									data
								);
								commit(
									SET_GLOBAL_TRANSACTIONS,
									globalTransactionsPayload
								);
								resolve(globalTransactionsPayload);
							}
						}
					})
					.catch(error => {
						if (error) {
							const errorMessage = exportData
								? 'An error occurred while processing your request. Please choose the Advanced Filters to narrow down the search results.'
								: error;

							dispatch(
								TOAST_MESSAGES_PUSH,
								{
									statusCode: 400,
									message: errorMessage
								},
								{
									root: true
								}
							);
							reject(error);
						}
					})
					.finally(() => {
						commit(SET_RELOAD_TRANSACTIONS, false);
					});
			});
		},
		async getGlobalTransactionById({ dispatch }, parameters) {
			return new Promise((resolve, reject) => {
				apiLogSupport
					.get(buildRoute(`/logs${baseApi}`, parameters))
					.then(res => {
						resolve(res);
					})
					.catch(error => {
						dispatch(
							TOAST_MESSAGES_PUSH,
							{
								statusCode: 400,
								message: error
							},
							{
								root: true
							}
						);
						reject(error);
					});
			});
		},
		[SET_RELOAD_TRANSACTIONS]({ commit }, value) {
			commit(SET_RELOAD_TRANSACTIONS, value);
		},
		async setTransactionAuditLog({ dispatch }, params) {
			Object.assign(params, {
				mutationType: SET_TRANSACTION_AUDIT_LOG
			});
			return dispatch('fetchDataAndCommit', params);
		},

		async getAllTransactionAuditLog({ dispatch }, params) {
			Object.assign(params, {
				mutationType: SET_ALL_TRANSACTION_AUDIT_LOG
			});
			return dispatch('fetchDataAndCommit', params);
		},

		async fetchDataAndCommit({ commit, dispatch }, params) {
			const { mutationType } = params;
			const valuesToRemove = [undefined, '', null];
			params = _.omitBy(params, value => valuesToRemove.includes(value));
			delete params.mutationType;

			try {
				commit(mutationType, {});
				const resp = await apiLogSupport.get(`logs${baseApi}/audit`, {
					params
				});
				commit(mutationType, resp);

				return Promise.resolve();
			} catch (error) {
				dispatch(
					TOAST_MESSAGES_PUSH,
					{
						statusCode: 400,
						message:
							mutationType === SET_ALL_TRANSACTION_AUDIT_LOG
								? `An error occurred while processing your request. Please choose the Filters to narrow down the search results.`
								: error
					},
					{
						root: true
					}
				);

				if (mutationType === SET_TRANSACTION_AUDIT_LOG) {
					commit(SET_RELOAD_TRANSACTIONS, false);
				}

				return Promise.reject();
			}
		}
	},
	getters: {
		[GLOBAL_TRANSACTIONS]: state => state[GLOBAL_TRANSACTIONS],
		[RELOAD_TRANSACTIONS]: state => state[RELOAD_TRANSACTIONS]
	}
};
